import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'
import { createTracker } from '@nrk/dh-snowplow'
import { EventSchema, ViewportEventKind } from '@nrk/snowplow-web'
// import hydrate from './components/hydrate'
import './client.module.css'
import './components/sitat-paa-bilde.module.css'
import './components/sitat-boks.module.css'
import './components/color-themes/color-themes.module.css'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

class AppElement extends HTMLElement {
  #entryObserver
  #exitObserver
  #tracker
  connectedCallback() {
    // Frem til nettleserene støtter `sizes=auto` for bilder med `loading=lazy` så må vi manuelt oppdatere sizes
    // for bredere bilder
    if (this.#isFeatureFullWidth() || this.#isFeatureCover()) {
      for (const source of this.querySelectorAll('source')) {
        source.setAttribute('sizes', '100vw')
      }
      this.querySelector('img').setAttribute('sizes', '100vw')
    }

    this.#createTracker()
    this.#startViewportLogger()
  }
  disconnectedCallback() {
    this.#stopViewportLogger()
  }

  #createTracker() {
    if (process.env.DEV) {
      import('@nrk/dh-snowplow/mock').then(({ mock }) => mock()).catch(console.error)
    }

    this.#tracker = createTracker('dh-sitat-paa-bilde', {
      environment: process.env.ENVIRONMENT,
      contentContext: {
        source: 'pp',
        id: this.dataset.selfId,
      },
    })
  }

  #startViewportLogger() {
    this.#entryObserver = new IntersectionObserver((entries) => {
      if (!entries[0]?.isIntersecting) {
        return
      }
      this.#entryObserver.disconnect()
      this.#exitObserver.observe(this)
      this.#tracker.trackSelfDescribingEvent({
        schema: EventSchema.ViewportEvent,
        data: {
          kind: ViewportEventKind.Entry,
        },
      })
    }, {})

    this.#exitObserver = new IntersectionObserver(
      (entries) => {
        if (!entries[0]?.isIntersecting) {
          return
        }
        this.#exitObserver.disconnect()
        this.#tracker.trackSelfDescribingEvent({
          schema: EventSchema.ViewportEvent,
          data: {
            kind: ViewportEventKind.Exit,
          },
        })
      },
      { threshold: [1], rootMargin: '99000px 0px -100% 0px' },
    )

    this.#entryObserver.observe(this)
  }

  #stopViewportLogger() {
    this.#entryObserver?.disconnect()
    this.#exitObserver?.disconnect()
  }

  #isFeatureFullWidth() {
    return !!this.closest?.(
      '.article-feature :is(.remoterenderedcontent-reference,.inlinesanitycontent-reference).fc',
    )
  }

  #isFeatureCover() {
    return !!this.closest?.('.article-feature__cover')
  }
}

if (!customElements.get(tag)) {
  customElements.define(tag, AppElement)
}
